var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('div', {
    staticClass: "sub-visual sub-visual--sv3"
  }, [_c('v-container', [_c('h2', {
    staticClass: "sub-visual__title"
  }, [_c('span', [_vm._v("PARTNERS")])])])], 1), _c('partners-list')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }